module.exports = __webpack_public_path__ + "img/6bb30fb.png";